import { type PropsWithChildren } from 'react';

import { CircularProgress } from '@mui/material';

import { ICON_SIZE_PX } from '../../../constants/buttons';
import { BLACK_COLOR } from '../../../constants/colors';
import { ITextButton } from '../../../interfaces/buttons';
import './TextButton.scss';

const TextButton = ({
  action,
  disabled,
  children,
  iconLeft,
  iconRight,
  loading = false,
  variant,
  size = 's'
}: PropsWithChildren<ITextButton>) => {
  if (loading) {
    return <CircularProgress sx={{ color: BLACK_COLOR }} size={ICON_SIZE_PX.s} />;
  }

  return (
    <button
      type="button"
      disabled={disabled}
      className={`flex border-0 box-border cursor-pointer items-center justify-center w-fit bg-transparent relative text-button text-button--${variant} text-button--${size}`}
      onClick={action}
    >
      {iconLeft && <iconLeft.component className="text-button__icon" />}
      {children}
      {iconRight && <iconRight.component className="text-button__icon" />}
    </button>
  );
};

export default TextButton;
